import { componentLoader } from '../ReactLazyUtils';
import { captureSentryException } from '../SentryUtils';

export const importAWSPackage = (): Promise<any> => {
  return componentLoader(() =>
    import(/* webpackChunkName: "AwsSdkPackage" */ 'aws-sdk')
      .then((AWS) => {
        return AWS;
      })
      .catch((error) => {
        captureSentryException(
          new Error('Failed to initialize aws-sdk package'),
          error
        );
      })
  );
};
